import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.newRelicFrontend.isEnabled) {
    loadBrowserAgentScript();
}
  
function loadBrowserAgentScript(): void {
    if (!environment.production) {
        return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;

    const fileName = 'newrelic-browser-agent.js';

    script.src = `assets/observability/${fileName}`;
    document.head.appendChild(script);
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));